import { ExpandMore as ExpandMoreIcon, OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import type { Theme } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetRegions } from '@/hooks/useGetRegions';
import { INDUSTRY_TRACKER_IMAGES } from '@/pages/LandingPage/constants';
import { FeatureEnum, IndustryTrackerTypeEnum } from '@/types/GraphqlSchema';
import { RegionEnum } from '@/types/RegionEnum';
import { M_A_OPPORTUNITIES_PATH } from '@/utils/constants';
import { Tracker } from './Tracker';

const useStyles = makeStyles((theme: Theme) => ({
  details: {
    padding: 0,
  },
  label: {
    textTransform: 'uppercase',
    [theme.breakpoints.down('lg')]: {
      fontSize: '10px',
    },
    fontWeight: 'bold',
  },
  summary: {
    '& > .MuiAccordionSummary-content': {
      alignItems: 'center',
    },
  },
}));

export const MaOpportunitiesList = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const regions = Object.values(RegionEnum);
  const { regions: userEntitledRegions } = useGetRegions({
    feature: FeatureEnum.MAndAOpportunities,
  });
  const history = useHistory();

  const onClick = (region: RegionEnum) => {
    history.push(`${M_A_OPPORTUNITIES_PATH}?region=${encodeURIComponent(region)}#table`);
  };

  const isUserEntitled = useCallback(
    (region: RegionEnum) => userEntitledRegions.some(r => r.displayName === region),
    [userEntitledRegions],
  );

  const image = INDUSTRY_TRACKER_IMAGES[IndustryTrackerTypeEnum.PotentialMaOpportunities];
  return (
    <Accordion square={true} expanded={expanded} onChange={(_, exp) => setExpanded(exp)}>
      <AccordionSummary
        className={classes.summary}
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel-layers'
      >
        <img src={image} width='20px' height='20px' alt={`${name}-icon`} />
        &nbsp;&nbsp;
        <Typography className={classes.label} variant='caption'>
          Potential M&amp;A Opportunities
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {regions.map(region => (
          <Tracker
            key={region}
            title={region || ''}
            onClick={() => onClick(region || '')}
            enabled={isUserEntitled(region)}
            Icon={OpenInNewIcon}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
